import Axios from "../config/config";


//microsoft api 
export const LIST_AZURE_CONFIG= async (body) => {
    try {
        const response = await Axios.post('list-azure-config/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const AZURE_CONFIG_STATUS= async (body) => {
    try {
        const response = await Axios.post('azure-config-status/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const DELETE_AZURE_CONFIG= async (body) => {
    try {
        const response = await Axios.post('delete-azure-config/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const ADD_AZURE_CONFIG= async (body) => {
    try {
        const response = await Axios.post('add-azure-config/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const EDIT_AZURE_CONFIG= async (body) => {
    try {
        const response = await Axios.post('edit-azure-config/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const VIEW_AZURE_CONFIG= async (body) => {
    try {
        const response = await Axios.post('view-azure-config/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};